module.exports = __webpack_public_path__ + "static/img/til6.e3c854b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/til6.png
// module id = wTMj
// module chunks = 0